import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

export default Component('tr-date-picker-field', {
  mixins: [eventListenerMixin],

  properties: {
    selected: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.nativeField.disabled = this.disabled;
      },
    },
  },

  ready() {
    this.selectedDates = [];

    this.nativeField = this.querySelector('.native-control-wrapper input');
    this.result = this.querySelector('.date-picker-field-result');
    this.list = this.querySelector('.date-picker-field-list');
    this.list.setAnchor(this.result);

    this.setValue(this.nativeField.value);
    this.addEventListeners();
  },

  disconnected() {
    this.stopListening();
  },

  addEventListeners() {
    this.listenTo(this.result, {
      'tao:activeClick': () => {
        if (!this.list.isOpen()) this.list.open();
      },
      'tao:clear': this.handleResultClear.bind(this),
    });

    this.listenTo(this.list, {
      'tr-date-picker-field-list:select': this.handleListSelect.bind(this),
      'tr-date-picker-field-list:clear': this.handleListClear.bind(this),
    });
  },

  getValue() {
    return this.nativeField.value;
  },

  setValue(value) {
    if (!value) return;

    this.list.setSelectedValue(value);
    this.setSelectedDates(this.list.selectedDates);
  },

  setSelectedDates(dates) {
    this.selectedDates = dates || [];
    this.selected = this.selectedDates.length > 0;

    this.result.setSelected(this.selectedDates);
    this.nativeField.value = this.list.selectedValue;
  },

  clearSelected() {
    this.selectedDates = [];
    this.selected = false;
    this.nativeField.value = '';
    this.list.clearSelected();
    this.result.clearSelected();
  },

  handleResultClear() {
    this.clearSelected();
    this.namespacedTrigger('change', {
      detail: this.getValue(),
      bubbles: true,
    });
  },

  handleListSelect(event) {
    this.setSelectedDates(event.detail);
    this.list.close();

    this.namespacedTrigger('change', {
      detail: this.getValue(),
      bubbles: true,
    });
  },

  handleListClear() {
    this.clearSelected();
    this.list.close();

    this.namespacedTrigger('change', {
      detail: this.getValue(),
      bubbles: true,
    });
  },
});
